<div style="width: 800px;">
  <div style="font-size: 20px; text-align: center; margin-bottom: 15px;"><B>EARLY PREGNANCY SCAN REPORT</B></div>
  <div style="background-color: black; height: 2px; width: 100%;"></div>

  <div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 10px; font-size: 14px;">
    <div style="font-size: 14px;">
      NAME:    <b> {{PATIENT_NAME}} </b>
    </div>
    <div style="margin-right: 40px;">
      AGE:    {{PATIENT_AGE}}
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 10px; font-size: 14px;">
    <div>
      LMP:    {{lmp}}
    </div>
    <div>
      G.A[LMP]:    {{ga}}
    </div>
    <div style="margin-right: 40px;">
      EDD[LMP]:    {{edd}}
    </div>
  </div>
  <div style="background-color: black; height: 2px; width: 100%; margin-top: 15px; margin-bottom: 15px;"></div>

  <div style="display: flex; flex-direction: row; justify-content: flex-start;">
    <table style="font-size: 16px;">
      <tr style="border: 0; padding: 0; margin: 0;">
        <td style="border: 0; padding: 0;"><b>Number Of Fetus(es) :</b> </td>
        <td style="border: 0; padding: 0;">{{no_of_fetus}}</td>
      </tr>
      <tr style="border: 0; padding: 0; margin: 0;">
        <td style="border: 0; padding: 0;"><b>Fetal Heart Rate:</b></td>
        <td style="border: 0; padding: 0;">{{fetal_heart_beat}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>Presentation :</b></td>
        <td style="border: 0; padding: 0;">{{crl}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>Fetal Lie :</b></td>
        <td style="border: 0; padding: 0;">{{nt_thikness}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>B.P.D (mm) :</b> </td>
        <td style="border: 0; padding: 0;">{{amniotic_fluids}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>F.I (mm) :</b></td>
        <td style="border: 0; padding: 0;">{{p_location}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>A.C (mm) :</b></td>
        <td style="border: 0; padding: 0;">{{us_average}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>H.C (mm)</b></td>
        <td style="border: 0; padding: 0;">{{uss_edd}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>Estimated Fetal Weight :</b> </td>
        <td style="border: 0; padding: 0;">{{genders}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>Gender :</b></td>
        <td style="border: 0; padding: 0;">{{right_adnexium}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>US Average G.A [wks] :</b></td>
        <td style="border: 0; padding: 0;">{{left_adnexium}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>US EDD :</b> </td>
        <td style="border: 0; padding: 0;">{{cervical_os}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>Placenta Location :</b> </td>
        <td style="border: 0; padding: 0;">mhtcdm</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>Amniotic Fluid :</b></td>
        <td style="border: 0; padding: 0;">{{fl}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>Fetal Anomally :</b> </td>
        <td style="border: 0; padding: 0;">{{ac}}</td>
      </tr>
      <tr style="border: 0;">
        <td style="border: 0; padding: 0;"><b>Cervical OS:</b></td>
        <td style="border: 0; padding: 0;">{{hc}}</td>
      </tr>
    </table>




    <table style="margin-left: 50px; font-size: 14px;">

    </table>
  </div>
  <div style="font-size: 20px; margin-top: 10px;"><b>Comments :</b></div>
  <div style="background-color: black; height: 2px; width: 100%; margin-bottom: 35px;"></div>
  <div style="font-size: 16px;">{{comments}}</div><br>

  <div style="background-color: black; height: 2px; width: 100%;"></div>


  <div style="font-size: 12px; text-align: center;">Electronically signed and Authenticated by : {{doctor_id}}</div>


</div>












<div style="width: 800px;">
  <div style="font-size: 20px; text-align: center; margin-bottom: 5px;"><B>ANOMALY SCAN ULTRASOUND SCAN REPORT</B></div>
  <div style="background-color: black; height: 2px; width: 100%;"></div>

  <div style="display: flex; flex-direction: row;">
    <div style="width: 48%;">
      <div style="padding: 20px 0;">
      <table border="0">
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Title</td>
          <td style="border: 0; padding: 0; margin: 0;">Mrs</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Name</td>
          <td style="border: 0; padding: 0; margin: 0;">Madu Mcbobby C</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Age</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Sex</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Referred Doctoe</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
      </table>
      </div>

      <div><u><b>Indication for Scan ans Relevant Clinical Information</b></u></div>
      <div style="padding: 20px 0;">
        <table border="0">
          <tr>
            <td style="border: 0; padding: 0; margin: 0;">LMP</td>
            <td style="border: 0; padding: 0; margin: 0;">G.A[LMP]</td>
          </tr>
          <tr>
            <td style="border: 0; padding: 0; margin: 0;">Technical Condition</td>
            <td style="border: 0; padding: 0; margin: 0;">lmp</td>
          </tr>
          <tr>
            <td style="border: 0; padding: 0; margin: 0;">Number of Fetus</td>
            <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          </tr>
          <tr>
            <td style="border: 0; padding: 0; margin: 0;">Chorionicity</td>
            <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          </tr>
          <tr>
            <td style="border: 0; padding: 0; margin: 0;">Placenta Location</td>
            <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          </tr>
          <tr>
            <td style="border: 0; padding: 0; margin: 0;">Cervical OS</td>
            <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          </tr>
          <tr>
            <td style="border: 0; padding: 0; margin: 0;">Fetal Movement</td>
            <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          </tr>
          <tr>
            <td style="border: 0; padding: 0; margin: 0;">Amniotic Fluid</td>
            <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          </tr>
        </table>
      </div>
      <table border="0">
        <tr>
          <td style="border: 0; padding: 0; margin: 0; border-top: 1px solid black; border-bottom: 1px solid black;"><b>Measurement</b></td>
          <td style="border: 0; padding: 0; margin: 0; border-top: 1px solid black; border-bottom: 1px solid black;"><b>mm</b></td>
          <td style="border: 0; padding: 0; margin: 0; border-top: 1px solid black; border-bottom: 1px solid black;"><b>Gestational Age</b></td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Biparietal Diameter</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Femur Diaphysis Length</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Abdominal Circumference</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Head Circumference</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Gestational Age[comp]</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Estimated Fetal weight</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
        <tr>
          <td style="border: 0; padding: 0; margin: 0;">Expected Delivery Date</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
          <td style="border: 0; padding: 0; margin: 0;">LMP</td>
        </tr>
      </table>
      <hr style="margin-top: 20px;">
      <div><b>Findings[please detail]</b></div>
      <hr>
      <div>viable singleton</div>

      <div style="margin-top: 240px;"><b>Conclusion</b></div>
      <hr>
      <div style="margin-top: 30px;">viable singleton</div>
      <hr style="margin-top: 10px;">
    </div>
    <div style="width: 50%;">
      <table border="2">
        <tbody>
          <tr>
            <td style="border-bottom: 1px solid black;">N=Normal <br>Ab=Abnormal<br>NV=Not Visualized</td>
            <td style="border-bottom: 1px solid black;">N</td>
            <td style="border-bottom: 1px solid black;">AB</td>
            <td style="border-bottom: 1px solid black;">NV</td>
          </tr>
          <tr>
            <td style="border: 0; padding: 0; margin: 0; border-top: 1px solid black; border-bottom: 1px solid black;"><b>Head</b></td>
            <td style="border: 0; padding: 0; margin: 0; border-top: 1px solid black; border-bottom: 1px solid black;"></td>
            <td style="border: 0; padding: 0; margin: 0; border-top: 1px solid black; border-bottom: 1px solid black;"></td>
            <td style="border: 0; padding: 0; margin: 0; border-top: 1px solid black; border-bottom: 1px solid black;"></td>
          </tr>
          <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Shape</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span>&nbsp; [[head_shape_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_shape_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_shape_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Cavum Ceptum pellucidi</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[head_cavum_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_cavum_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_cavum_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Midline Fallax</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[head_midline_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_midline_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_midline_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Thallamine</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[head_thalami_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_thalami_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_thalami_nv]]</td>
           </tr>
           <tr style="border: 0; padding: 0; margin: 0;">
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Lateral Ventride</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[head_lateral_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_lateral_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_lateral_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Cerebullum</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[head_cere_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_cere_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[head_cere_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;"><span lang="EN-GB">Face</span></td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Upper Lips</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[face_upp_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[face_upp_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[face_upp_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Orbits</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[face_orbit_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[face_orbit_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[face_orbit_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Nose</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[face_nose_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[face_nose_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[face_nose_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Neck</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[neck1]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[neck2]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[neck3]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;"><span lang="EN-GB">Thorax</span></td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Shape</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[tho_shape_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[tho_shape_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[tho_shape_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">No Masses</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[tho_mass_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[tho_mass_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[tho_mass_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;"><span lang="EN-GB">Heart</span></td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Heart Activity</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[heart_activity_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[heart_activity_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[heart_activity_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Size</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[heart_size_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[heart_size_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[heart_size_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Cardiac axis</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[heart_cadic_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[heart_cadic_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[heart_cadic_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Four-chamber view</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[heart_chamber_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[heart_chamber_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[heart_chamber_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;"><span lang="EN-GB">Abdomen</span></td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Diaphgram</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[abdo_dia_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_dia_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_dia_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Stomach</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[abdo_sto_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_sto_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_sto_nv]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Bowel</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[abdo_bowel_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_bowel_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_bowel_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Kidneys</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[abdo_kidney_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_kidney_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_kidney_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Urinary Bladder</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[abdo_unary_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_unary_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_unary_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Abdomen cordinsertion</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[abdo_insert_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_insert_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_insert_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Cord vessels</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[abdo_vessel_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_vessel_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[abdo_vessel_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Spine</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[spine1]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[spine2]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[spine3]]</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;"><span lang="EN-GB">Limbs</span></td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
            <td style="border: 0; padding: 0; margin: 0; border-bottom: 1px solid black; border-top: 1px solid black;">&nbsp;</td>
           </tr>
           <tr >
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Right Arm</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[limbs_ra_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[limbs_ra_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[limbs_ra_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Right Leg</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[limbs_rl_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[limbs_rl_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[limbs_rl_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Left Arm</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[limbs_la_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[limbs_la_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[limbs_la_nv]]</td>
           </tr>
           <tr>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">Left Leg</span></td>
            <td style="border: 0; padding: 0; margin: 0;"><span lang="EN-GB">&nbsp; [[limbs_ll_n]]</span></td>
            <td style="border: 0; padding: 0; margin: 0;">[[limbs_ll_ab]]</td>
            <td style="border: 0; padding: 0; margin: 0;">[[limbs_ll_nv]]</td>
           </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div style="height: 2px; width: 100%; background-color: black; margin-top: 20px;"></div>
  <div style="margin-top: 10px; text-align: center;"> Electronically signed and Authenticated By: <b>Dr mt name</b></div>

</div>



EARLY PREGNANCY SCAN REPORT


Name: [[PATIENT_TITLE]] [[PATIENT_NAME]]                                                                       Sex: [[PATIENT_GENDER]]

REFERRED BY: [[REFERRED_BY]]

 AGE : [[PATIENT_AGE]]               LMP : [[lmp]]               G.A [LMP] : [[ga]]                  EDD [LMP] : [[edd]]



 [[ftimage]]



 Number of Fetus(es) :    [[no_of_fetus]]

Fetal Heart :                        [[fetal_heart_beat]]

Mean G.S.D (mm):[[mean_gsd]]

C.R.L (mm) :                        [[crl]]

N.T Thickness (mm) :[[nt_thikness]]

Amniotic Fluid :[[amniotic_fluid]]                                                                                 Technical Conditions : [[tech_condition]]

Placenta location :[[p_location]]

Gender :            [[gender]]

US Average G.A [wks]    [[us_average]]

US EDD :   [[uss_edd]]

Right Adnexium : [[right_adnexium]]

Left Adnexium : [[left_adnexium]]

Cervical OS :  [[cervical_os]]

Other Findings:



[[other_finding]]

Comments :



[[comments]]

Suggestion:



[[suggestion1]]

[[suggestion2]]






















<p class="MsoNormal" align="center"><span><img width="824" height="6" src="file:///C:/Users/Favor/AppData/Local/Temp/msohtmlclip1/01/clip_image001.png"></span><b><span lang="EN-GB">ANOMALY SCAN ULTRASOUND</span><span lang="en-NG"> SCAN REPORT</span></b></p><p class="MsoNormal" align="center"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAzgAAAAGCAYAAAAPFDvCAAABIUlEQVR4Ae2asQ2GIBCFGYOSUSwZxS0YwVEYgTEoLR2Bkj9nYvK3FCT4/EgudkQ+T3j3DtcZEIAABCAAAQhAAAIQmEigtdZLKTJxHEdPKUnEvu992zaZuK6ru4m5zNQQgAAEIAABSQK1VhmhlnOWEGmP2Iwxygi1EEJ3zhEwIAcGcuA8TwocyZOXRUFggACu2roOnJqrhlBDqJID384BpS6B7c9PUf32p3WjlLprpmvkOji4auuKNVy1bx9sCBu+v1IOmLOuItZsb367QPt/f+tIqYg10zQMCEBgnMBd4HjvaX0NtL6UDmnWgui0HFARarYOXLV177ibq8aAAAQgAAEIzCZwFzhKdzxx1dbt4OCqzf6dmR8CEIAABCAAAQhA4AdVq8F+2CJkAAAAAABJRU5ErkJggg==" alt=""><b><span lang="en-NG"><br></span></b></p>

<p class="MsoNormal"><span lang="EN-GB">Surname: [[PATIENT_TITLE]] [[PATIENT_NAME]]&nbsp; </span></p>

<p class="MsoNormal"><span>Age:&nbsp;</span><span>[[PATIENT_AGE]]&nbsp;</span><br></p>

<p class="MsoNormal"><span lang="EN-GB">Sex: [[PATIENT_GENDER]]</span></p>

<p class="MsoNormal"><span lang="EN-GB">REFERRED DOCTOR:
[[REFERRED_BY]]<b></b></span></p>

<p class="MsoNormal"><b><u><span lang="EN-GB">Indication
For Scan and Relevant Clinical Information</span></u></b><b><span lang="EN-GB"></span></b></p><p class="MsoNormal"><b><u><span lang="EN-GB"><br></span></u></b></p><p class="MsoNormal">[[ftimage]]<u><span lang="EN-GB"><br></span></u></p><p class="MsoNormal"><u><span lang="EN-GB"><b><br></b></span></u></p><p class="MsoNormal"><u><span lang="EN-GB"><b><br></b></span></u></p>

<p class="MsoNormal"><span lang="en-NG">LMP : [[lmp]]&nbsp; </span></p>

<p class="MsoNormal"><span lang="en-NG">G.A [LMP] : [[ga]]&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  EDD [LMP] : [[edd]]</span></p>

<p class="MsoNormal"><span lang="EN-GB">Technical
Condition:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  [[tech_condition]]&nbsp;</span></p>

<p class="MsoNormal"><span lang="en-NG">Number of Fetus(es) :</span><span lang="en-NG"> </span><span lang="EN-GB">&nbsp;&nbsp; [[no_of_fetus]]</span></p>

<p class="MsoNormal"><span lang="en-NG">Chorionicity :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[[chorionicity]]&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></p>

<p class="MsoNormal"><span lang="EN-GB">Placenta Location:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; [[p_location]]&nbsp;</span></p>

<p class="MsoNormal"><span lang="en-NG">Cervical OS :</span><span lang="EN-GB">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; [[cervical_os]]</span></p>

<p class="MsoNormal"><span lang="EN-GB">Fetal
Movement:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></p>

<p class="MsoNormal"><span lang="en-NG">Amniotic
Fluid :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span lang="EN-GB">[[amniotic_fluid]]&nbsp;&nbsp;</span></p><p class="MsoNormal"><span lang="EN-GB"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWQAAAABCAYAAADpVdR9AAAAI0lEQVQ4EWMIDQ3dz8DA8H8Uj4bBaBoYTQOjaWDg0gCoLAYAR7ZkKuUluCYAAAAASUVORK5CYII=" alt=""><br></span></p>

<p class="MsoNormal"><b><span lang="EN-GB">Measurements&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;mm&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;Gestation
Age</span></b></p><p class="MsoNormal"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWQAAAABCAYAAADpVdR9AAAAI0lEQVQ4EWMIDQ3dz8DA8H8Uj4bBaBoYTQOjaWDg0gCoLAYAR7ZkKuUluCYAAAAASUVORK5CYII=" alt=""><b><span lang="EN-GB"><br></span></b></p>

<p class="MsoNormal"><b><span lang="EN-GB">Biparietal Diameter&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;[[bd_mm]] [[bd_ga]]&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></b></p>

<p class="MsoNormal"><b><span lang="EN-GB">Femur
Diaphysis Length:&nbsp; &nbsp;[[fdl_mm]]&nbsp;</span></b><b><span lang="EN-GB">[[fdl_ga]]</span></b><b><span lang="EN-GB">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></b></p>

<p class="MsoNormal"><b><span lang="EN-GB">Abdominal
Circumference:&nbsp; &nbsp; [[ac_mm]]&nbsp;</span></b><b><span lang="EN-GB">[[ac_ga]]</span></b><b><span lang="EN-GB">&nbsp; &nbsp;</span></b></p>

<p class="MsoNormal"><b><span lang="EN-GB">Head
Circumference:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;[[hc_mm]]&nbsp;&nbsp;</span></b><b><span lang="EN-GB">[[hc_ga]]</span></b><b><span lang="EN-GB">&nbsp; &nbsp;&nbsp;</span></b></p>

<p class="MsoNormal"><b><span lang="EN-GB">Gestation
Age (COMP):&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;[[g_age]]&nbsp;</span></b></p>

<p class="MsoNormal"><b><span lang="EN-GB">Estimated
Fetal weight:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; [[efw]]</span></b></p>

<p class="MsoNormal"><b><span lang="EN-GB">Expected
Delivery Date:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; [[exdd]]</span></b></p><p class="MsoNormal"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWQAAAABCAYAAADpVdR9AAAAI0lEQVQ4EWMIDQ3dz8DA8H8Uj4bBaBoYTQOjaWDg0gCoLAYAR7ZkKuUluCYAAAAASUVORK5CYII=" alt=""><b><span lang="EN-GB"><br></span></b></p>

<p class="MsoNormal"><b><span lang="EN-GB">Findings (please Details):&nbsp;&nbsp;</span></b><span><b>[[other_finding]]</b></span></p><p class="MsoNormal"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWQAAAABCAYAAADpVdR9AAAAI0lEQVQ4EWMIDQ3dz8DA8H8Uj4bBaBoYTQOjaWDg0gCoLAYAR7ZkKuUluCYAAAAASUVORK5CYII=" alt=""></p>

<p class="MsoNormal"><span lang="EN-GB">&nbsp;</span></p>

<p class="MsoNormal"><b><span lang="EN-GB">Conclusion</span><span lang="en-NG">:&nbsp;&nbsp;</span></b><span><b>[[comments]]</b></span></p>

<p class="MsoNormal"><br></p><p class="MsoNormal"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAqUAAAACCAYAAABhXqVNAAAAPklEQVRYCe3WMQ0AAAwCMPybZkHFnh4YgB4kSUUHDDDAAAMMMMAAA18G2u6PGkAHDDDAAAMMMMAAA38GdkoPPwtK/GEqivYAAAAASUVORK5CYII=" alt=""><b><span lang="EN-GB"><br></span></b></p>

<p class="MsoNormal" align="center"><span lang="en-NG">Electronically signed and</span><span lang="EN-GB">
Authenticated By: </span><span lang="EN-GB"> </span><span lang="EN-GB">&nbsp;</span><span lang="EN-GB">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span lang="en-NG">DR
NWAKOR S.I</span></p><p class="MsoNormal" align="center"><span lang="en-NG"><br></span></p><p class="MsoNormal" align="center"><span lang="en-NG"></span></p><table border="0" cellpadding="0" cellspacing="0" width="325">
 <colgroup><col width="133">
 <col width="64" span="2">
 <col width="64">
 </colgroup><tbody><tr height="20">
  <td height="20" class="xl83" width="133"><span lang="EN-GB">N = Normal</span></td>
  <td rowspan="3" class="xl75" width="64"><span lang="EN-GB">N</span></td>
  <td rowspan="3" class="xl72" width="64"><span lang="EN-GB">Ab</span></td>
  <td rowspan="3" class="xl66" width="64"><span lang="EN-GB">Nv</span></td>
 </tr>
 <tr height="20">
  <td height="20" class="xl83" width="133"><span lang="EN-GB">Ab&nbsp;&nbsp; = Abnormal</span></td>
 </tr>
 <tr height="20">
  <td height="20" class="xl78" width="133"><span lang="EN-GB">Nv = Not Visualized</span></td>
 </tr>
 <tr height="20">
  <td height="20" class="xl82" width="133"><span lang="EN-GB">Head&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></td>
  <td class="xl71" width="64">&nbsp;</td>
  <td class="xl70" width="64">&nbsp;</td>
  <td class="xl94" width="64">&nbsp;</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Shape</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[head_shape_n]]</span></td>
  <td class="xl97" width="64">[[head_shape_ab]]</td>
  <td class="xl95" width="64">[[head_shape_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Cavum Ceptum pellucidi</span></td>
  <td class="xl90" width="64"><span lang="EN-GB">&nbsp; [[head_cavum_n]]</span></td>
  <td class="xl88" width="64">[[head_cavum_ab]]</td>
  <td class="xl93" width="64">[[head_cavum_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Midline Fallax</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[head_midline_n]]</span></td>
  <td class="xl97" width="64">[[head_midline_ab]]</td>
  <td class="xl95" width="64">[[head_midline_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Thallamine</span></td>
  <td class="xl90" width="64"><span lang="EN-GB">&nbsp; [[head_thalami_n]]</span></td>
  <td class="xl88" width="64">[[head_thalami_ab]]</td>
  <td class="xl93" width="64">[[head_thalami_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Lateral Ventride</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[head_lateral_n]]</span></td>
  <td class="xl97" width="64">[[head_lateral_ab]]</td>
  <td class="xl95" width="64">[[head_lateral_nv]]</td>
 </tr>
 <tr height="25">
  <td height="25" class="xl65" width="133"><span lang="EN-GB">Cerebullum</span></td>
  <td class="xl90" width="64"><span lang="EN-GB">&nbsp; [[head_cere_n]]</span></td>
  <td class="xl88" width="64">[[head_cere_ab]]</td>
  <td class="xl93" width="64">[[head_cere_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl84" width="133"><span lang="EN-GB">Face</span></td>
  <td class="xl87" width="64">&nbsp;</td>
  <td class="xl98" width="64">&nbsp;</td>
  <td class="xl94" width="64">&nbsp;</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Upper Lips</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[face_upp_n]]</span></td>
  <td class="xl88" width="64">[[face_upp_ab]]</td>
  <td class="xl93" width="64">[[face_upp_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Orbits</span></td>
  <td class="xl100" width="64"><span lang="EN-GB">&nbsp; [[face_orbit_n]]</span></td>
  <td class="xl101" width="64">[[face_orbit_ab]]</td>
  <td class="xl95" width="64">[[face_orbit_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Nose</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[face_nose_n]]</span></td>
  <td class="xl99" width="64">[[face_nose_ab]]</td>
  <td class="xl95" width="64">[[face_nose_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl83" width="133"><span lang="EN-GB">Neck</span></td>
  <td class="xl90" width="64"><span lang="EN-GB">&nbsp; [[neck1]]</span></td>
  <td class="xl88" width="64">[[neck2]]</td>
  <td class="xl93" width="64">[[neck3]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl83" width="133"><span lang="EN-GB">Thorax</span></td>
  <td class="xl81" width="64">&nbsp;</td>
  <td class="xl70" width="64">&nbsp;</td>
  <td class="xl94" width="64">&nbsp;</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Shape</span></td>
  <td class="xl100" width="64"><span lang="EN-GB">&nbsp; [[tho_shape_n]]</span></td>
  <td class="xl102" width="64">[[tho_shape_ab]]</td>
  <td class="xl95" width="64">[[tho_shape_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">No Masses</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[tho_mass_n]]</span></td>
  <td class="xl88" width="64">[[tho_mass_ab]]</td>
  <td class="xl93" width="64">[[tho_mass_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl83" width="133"><span lang="EN-GB">Heart</span></td>
  <td class="xl71" width="64">&nbsp;</td>
  <td class="xl70" width="64">&nbsp;</td>
  <td class="xl94" width="64">&nbsp;</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Heart Activity</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[heart_activity_n]]</span></td>
  <td class="xl88" width="64">[[heart_activity_ab]]</td>
  <td class="xl93" width="64">[[heart_activity_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Size</span></td>
  <td class="xl100" width="64"><span lang="EN-GB">&nbsp; [[heart_size_n]]</span></td>
  <td class="xl102" width="64">[[heart_size_ab]]</td>
  <td class="xl95" width="64">[[heart_size_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Cardiac axis</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[heart_cadic_n]]</span></td>
  <td class="xl88" width="64">[[heart_cadic_ab]]</td>
  <td class="xl93" width="64">[[heart_cadic_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Four-chamber view</span></td>
  <td class="xl90" width="64"><span lang="EN-GB">&nbsp; [[heart_chamber_n]]</span></td>
  <td class="xl88" width="64">[[heart_chamber_ab]]</td>
  <td class="xl93" width="64">[[heart_chamber_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl78" width="133"><span lang="EN-GB">Abdomen</span></td>
  <td class="xl87" width="64">&nbsp;</td>
  <td class="xl85" width="64">&nbsp;</td>
  <td class="xl68" width="64">&nbsp;</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Diaphgram</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[abdo_dia_n]]</span></td>
  <td class="xl88" width="64">[[abdo_dia_ab]]</td>
  <td class="xl93" width="64">[[abdo_dia_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Stomach</span></td>
  <td class="xl100" width="64"><span lang="EN-GB">&nbsp; [[abdo_sto_n]]</span></td>
  <td class="xl102" width="64">[[abdo_sto_ab]]</td>
  <td class="xl95" width="64">[[abdo_sto_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Bowel</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[abdo_bowel_n]]</span></td>
  <td class="xl88" width="64">[[abdo_bowel_ab]]</td>
  <td class="xl93" width="64">[[abdo_bowel_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl86" width="133"><span lang="EN-GB">Kidneys</span></td>
  <td class="xl91" width="64"><span lang="EN-GB">&nbsp; [[abdo_kidney_n]]</span></td>
  <td class="xl97" width="64">[[abdo_kidney_ab]]</td>
  <td class="xl95" width="64">[[abdo_kidney_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Urinary Bladder</span></td>
  <td class="xl90" width="64"><span lang="EN-GB">&nbsp; [[abdo_unary_n]]</span></td>
  <td class="xl88" width="64">[[abdo_unary_ab]]</td>
  <td class="xl93" width="64">[[abdo_unary_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Abdomen cord
  insertion</span></td>
  <td class="xl90" width="64"><span lang="EN-GB">&nbsp; [[abdo_insert_n]]</span></td>
  <td class="xl97" width="64">[[abdo_insert_ab]]</td>
  <td class="xl95" width="64">[[abdo_insert_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl80" width="133"><span lang="EN-GB">Cord vessels</span></td>
  <td class="xl92" width="64"><span lang="EN-GB">&nbsp; [[abdo_vessel_n]]</span></td>
  <td class="xl97" width="64">[[abdo_vessel_ab]]</td>
  <td class="xl95" width="64">[[abdo_vessel_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl84" width="133"><span lang="EN-GB">Spine</span></td>
  <td class="xl92" width="64"><span lang="EN-GB">&nbsp; [[spine1]]</span></td>
  <td class="xl88" width="64">[[spine2]]</td>
  <td class="xl93" width="64">[[spine3]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl82" width="133"><span lang="EN-GB">Limbs</span></td>
  <td class="xl81" width="64">&nbsp;</td>
  <td class="xl70" width="64">&nbsp;</td>
  <td class="xl94" width="64">&nbsp;</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl79" width="133"><span lang="EN-GB">Right Arm</span></td>
  <td class="xl89" width="64"><span lang="EN-GB">&nbsp; [[limbs_ra_n]]</span></td>
  <td class="xl97" width="64">[[limbs_ra_ab]]</td>
  <td class="xl95" width="64">[[limbs_ra_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl65" width="133"><span lang="EN-GB">Right Leg</span></td>
  <td class="xl90" width="64"><span lang="EN-GB">&nbsp; [[limbs_rl_n]]</span></td>
  <td class="xl97" width="64">[[limbs_rl_ab]]</td>
  <td class="xl95" width="64">[[limbs_rl_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl80" width="133"><span lang="EN-GB">Left Arm</span></td>
  <td class="xl92" width="64"><span lang="EN-GB">&nbsp; [[limbs_la_n]]</span></td>
  <td class="xl97" width="64">[[limbs_la_ab]]</td>
  <td class="xl95" width="64">[[limbs_la_nv]]</td>
 </tr>
 <tr height="20">
  <td height="20" class="xl80" width="133"><span lang="EN-GB">Left Leg</span></td>
  <td class="xl92" width="64"><span lang="EN-GB">&nbsp; [[limbs_ll_n]]</span></td>
  <td class="xl95" width="64">[[limbs_ll_ab]]</td>
  <td class="xl93" width="64">[[limbs_ll_nv]]</td>
 </tr>
 <tr height="21">
  <td colspan="4" height="21" class="xl69" width="325"><span lang="EN-GB">Gender(optional)<font class="font0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  [[gender]]</font></span></td>
 </tr></tbody></table>


